;(function () {
	const initialized = new WeakSet()

	function initCarousel(root) {
		if (initialized.has(root)) return

		const track = root.querySelector("[data-testimonials-track]")
		const viewport = root.querySelector("[data-testimonials-viewport]")
		if (!track || !viewport) return

		const slides = track.querySelectorAll("[data-testimonials-slide]")
		const count = slides.length
		if (count <= 1) return

		initialized.add(root)

		const dots = root.querySelectorAll("[data-testimonials-dot]")
		/* testimonials.liquid: data-autoplay="true" | "false" */
		const autoplayEnabled = root.getAttribute("data-autoplay") === "true"
		const intervalMs = parseInt(String(root.dataset.autoplayMs || "6000"), 10)
		const slideMs = Number.isFinite(intervalMs) && intervalMs > 0 ? intervalMs : 6000

		let index = 0
		let timer = null
		let slideWidth = 0
		let dragOffset = 0
		let dragStartX = 0
		let activePointerId = null

		const ro = new ResizeObserver(() => measure())
		ro.observe(viewport)

		function setIndex(next) {
			index = ((next % count) + count) % count
			dragOffset = 0
			track.classList.remove("is-dragging")
			applyTransform()
			dots.forEach((dot, j) => {
				const active = j === index
				dot.classList.toggle("is-active", active)
				dot.setAttribute("aria-selected", active ? "true" : "false")
			})
		}

		function applyTransform() {
			const base = -index * slideWidth - dragOffset
			track.style.transform = `translate3d(${base}px, 0, 0)`
		}

		function measure() {
			slideWidth = viewport.getBoundingClientRect().width
			if (!slideWidth) return
			const total = slideWidth * count
			track.style.width = `${total}px`
			slides.forEach((slide) => {
				slide.style.flex = `0 0 ${slideWidth}px`
				slide.style.width = `${slideWidth}px`
				slide.style.minWidth = `${slideWidth}px`
			})
			applyTransform()
		}

		function stop() {
			if (timer) {
				clearInterval(timer)
				timer = null
			}
		}

		function start() {
			stop()
			if (!autoplayEnabled) return
			timer = window.setInterval(() => setIndex(index + 1), slideMs)
		}

		function onPointerLeaveRoot() {
			if (!root.matches(":focus-within")) start()
		}

		dots.forEach((dot) => {
			dot.addEventListener("click", () => {
				const i = parseInt(String(dot.dataset.index || "0"), 10)
				setIndex(i)
				stop()
				start()
			})
		})

		root.addEventListener("mouseenter", stop)
		root.addEventListener("mouseleave", onPointerLeaveRoot)
		root.addEventListener("focusin", stop)
		root.addEventListener("focusout", () => {
			requestAnimationFrame(() => {
				if (!root.contains(document.activeElement)) start()
			})
		})

		document.addEventListener("visibilitychange", () => {
			if (document.hidden) stop()
			else onPointerLeaveRoot()
		})

		function onPointerDown(e) {
			if (e.pointerType === "mouse" && e.button !== 0) return
			activePointerId = e.pointerId
			dragStartX = e.clientX
			dragOffset = 0
			track.classList.add("is-dragging")
			stop()
			try {
				viewport.setPointerCapture(e.pointerId)
			} catch (_) {}
		}

		function onPointerMove(e) {
			if (activePointerId !== e.pointerId) return
			const dx = e.clientX - dragStartX
			dragOffset = -dx
			applyTransform()
			if (Math.abs(dx) > 10) {
				e.preventDefault()
			}
		}

		function endDrag(e, commit) {
			if (activePointerId !== e.pointerId) return
			const dx = e.clientX - dragStartX
			activePointerId = null
			const threshold = Math.max(48, slideWidth * 0.12)
			track.classList.remove("is-dragging")

			if (commit && slideWidth) {
				if (dx > threshold) {
					setIndex(index - 1)
				} else if (dx < -threshold) {
					setIndex(index + 1)
				} else {
					setIndex(index)
				}
			} else {
				setIndex(index)
			}
			start()
			try {
				viewport.releasePointerCapture(e.pointerId)
			} catch (_) {}
		}

		function onPointerUp(e) {
			endDrag(e, true)
		}

		function onPointerCancel(e) {
			endDrag(e, false)
		}

		viewport.addEventListener("pointerdown", onPointerDown)
		viewport.addEventListener("pointermove", onPointerMove, { passive: false })
		viewport.addEventListener("pointerup", onPointerUp)
		viewport.addEventListener("pointercancel", onPointerCancel)

		measure()
		setIndex(0)
		start()
	}

	function initAll() {
		document.querySelectorAll("[data-testimonials-carousel]").forEach(initCarousel)
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", initAll, { once: true })
	} else {
		initAll()
	}

	document.addEventListener("shopify:section:load", (event) => {
		const section = event.target
		if (!(section instanceof HTMLElement)) return
		section.querySelectorAll("[data-testimonials-carousel]").forEach((el) => {
			initialized.delete(el)
			initCarousel(el)
		})
	})
})()
